import React from "react";
import styled from "styled-components";
import { Data } from "../Data";

const About = () => {
  const data = Data;
  return (
    <StyledAbout id="about">
      <h1>{data.aboutTitle}</h1>
      {data.aboutOptionOne ? (
        <div className="grid">
          <div>
            <h2>{data.aboutOption1.aboutTitle1}</h2>
            <p>{data.aboutOption1.aboutDescription1}</p>
          </div>
          <div>
            <h2>{data.aboutOption1.aboutTitle2}</h2>
            <p>{data.aboutOption1.aboutDescription2}</p>
          </div>
          <div>
            <h2>{data.aboutOption1.aboutTitle3}</h2>
            <p>{data.aboutOption1.aboutDescription3}</p>
          </div>
        </div>
      ) : (
        <img
          src={data.aboutOption2.aboutImage}
          alt={data.aboutTitle}
        />
      )}
    </StyledAbout>
  );
};

export default About;

const StyledAbout = styled.section`
  height: fit-content;
  background: #5f7769;
  padding: 0 3rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  @media (max-width: 992px) {
    height: fit-content;
    padding-bottom: 15vh;
  }
  h1 {
    padding-top: 20vh;
  }
  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 2rem;
    @media (max-width: 992px) {
      grid-template-columns: 1fr;
    }
    margin-bottom: 20vh;
  }
  img {
    width: 80vw;
    margin-bottom: 20vh;
    border-radius: 0.5rem;
  }
`;
